import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";

export interface BuyerSellerDetails {
  // Common Details
  tcId: string;
  // Seller Details
  sellerLicenseNumber: string;
  sellingOnBehalfOfFlag: string;
  sellerName: string;
  sellerTEId: string;
  sellerAddress1: string;
  sellerAddress2: string;
  sellerAddress3: string;
  sellerPostcode: string;
  sellerTown: string;
  sellerStateOrProvince: string;
  sellerCountryOrArea: string;
  sellerCertifiedOrganizationName: string;
  sellerSCNumber: string;
  tcSellerProductDeclarations: string;
  // Buyer Details
  buyerLicenseNumber: string;
  buyingOnBehalfOfFlag: string;
  buyerName: string;
  buyerTEId: string;
  buyerAddress1: string;
  buyerAddress2: string;
  buyerAddress3: string;
  buyerPostcode: string;
  buyerTown: string;
  buyerStateOrProvince: string;
  buyerCountryOrArea: string;
  buyerCertifiedOrganizationName: string;
  buyerSCNumber: string;
  isBuyerTeCertified: string;
  // Non-Certified Trader
  nonCertifiedTrader: INonCertifiedTrader[];
}

export interface INonCertifiedTrader {
  sellerNonCertifiedTraderName: string;
  sellerNonCertifiedTraderTeId: string;
}

export const buyerSellerDetails: BuyerSellerDetails = {
  // Common Details
  tcId: "",
  // Seller Details
  isBuyerTeCertified: "Yes",
  sellerLicenseNumber: "",
  sellingOnBehalfOfFlag: "Yes",
  sellerName: "",
  sellerTEId: "",
  sellerAddress1: "",
  sellerAddress2: "",
  sellerAddress3: "",
  sellerPostcode: "",
  sellerTown: "",
  sellerStateOrProvince: "",
  sellerCountryOrArea: "",
  sellerCertifiedOrganizationName: "",
  sellerSCNumber: "",
  tcSellerProductDeclarations: "",
  // Buyer Details
  buyerLicenseNumber: "",
  buyingOnBehalfOfFlag: "Yes",
  buyerName: "",
  buyerTEId: "",
  buyerAddress1: "",
  buyerAddress2: "",
  buyerAddress3: "",
  buyerPostcode: "",
  buyerTown: "",
  buyerStateOrProvince: "",
  buyerCountryOrArea: "",
  buyerCertifiedOrganizationName: "",
  buyerSCNumber: "",
  // Non-Certified Trader
  nonCertifiedTrader: [],
};

export const mapBuyerSellerDetailsApiResponseToInitialValues = (data: any) => {
  return {
    tcId: data.tcId || "",
    // Seller Details - Updated to match API response structure
    sellerLicenseNumber: data.sellerInformation?.sellerCbClientNo || "",
    sellingOnBehalfOfFlag: data.sellerInformation?.sellingOnBehalfOfFlag || "Yes",
    sellerName: data.sellerInformation?.sellerName || "",
    sellerTEId: data.sellerInformation?.sellerTeId || "",
    sellerAddress1: data.sellerInformation?.sellerStreetAddress || "",
    sellerAddress2: data.sellerInformation?.sellerAddress2 || "",
    sellerAddress3: data.sellerInformation?.sellerAddress3 || "",
    sellerPostcode: data.sellerInformation?.sellerPostcode || "",
    sellerTown: data.sellerInformation?.sellerTown || "",
    sellerStateOrProvince: data.sellerInformation?.sellerStateOrProvince || "",
    sellerCountryOrArea: data.sellerInformation?.sellerCountryOrArea || "",
    sellerCertifiedOrganizationName: data.sellerInformation?.sellerCertifiedOrganizationName || "",
    sellerSCNumber: data.sellerInformation?.sellerScNo || "",
    tcSellerProductDeclarations: data.sellerInformation?.tcSellerProductDeclarations || "",
    // Buyer Details - Updated to match API response structure
    buyerLicenseNumber: data.buyerInformation?.buyerCbClientNo || "",
    buyingOnBehalfOfFlag: data.buyerInformation?.buyingOnBehalfOfFlag || "Yes",
    buyerName: data.buyerInformation?.buyerName || "",
    buyerTEId: data.buyerInformation?.buyerTeId || "",
    buyerAddress1: data.buyerInformation?.buyerStreetAddress || "",
    buyerAddress2: data.buyerInformation?.buyerAddress2 || "",
    buyerAddress3: data.buyerInformation?.buyerAddress3 || "",
    buyerPostcode: data.buyerInformation?.buyerPostcode || "",
    buyerTown: data.buyerInformation?.buyerTown || "",
    buyerStateOrProvince: data.buyerInformation?.buyerStateOrProvince || "",
    buyerCountryOrArea: data.buyerInformation?.buyerCountryOrArea || "",
    buyerCertifiedOrganizationName: data.buyerInformation?.buyerCertifiedOrganizationName || "",
    buyerSCNumber: data.buyerInformation?.buyerScNo || "",
    isBuyerTeCertified: data.buyerInformation?.isBuyerTeCertified || "Yes",
    // Non-Certified Trader
    nonCertifiedTrader: data.sellerNonCertifiedTraderInformation || []
  };
};

export const mapPayload = (jsonData: any, tcId: any, buyerStates?: any, sellerStates?: any,sellerScStandards?: string[]) => {
  return {
    tcId: tcId,
    sellerInformation: {
      sellerCbClientNo: jsonData.sellerLicenseNumber || "",
      sellingOnBehalfOfFlag: jsonData.sellingOnBehalfOfFlag || "Yes", // Default value as per the payload
      sellerName: jsonData.sellerName || "",
      sellerTeId: jsonData.sellerTEId || "",
      sellerStreetAddress: jsonData.sellerAddress1 || "",
      sellerAddress2: jsonData.sellerAddress2 || "",
      sellerAddress3: jsonData.sellerAddress3 || "",
      sellerPostcode: jsonData.sellerPostcode || "",
      sellerTown: jsonData.sellerTown || "",
      sellerStateOrProvince: jsonData.sellerStateOrProvince || "",
      sellerCountryOrArea: jsonData.sellerCountryOrArea || "",
      sellerCertifiedOrganizationName: jsonData.sellerCertifiedOrganizationName || "",
      sellerScNo: jsonData.sellerSCNumber || "",
      sellerScStandard: sellerScStandards || [],
      tcSellerProductDeclarations: jsonData.tcSellerProductDeclarations || "",
      sellerCountryOrAreaDescription: useTransactionCertificateStore.getState().getCountryCodes.find((option: any) => option.value === (jsonData.sellerCountryOrArea ?? ""))?.label ?? "",  
      sellerStateOrProvinceDescription: sellerStates.find((option: any) => option.value === (jsonData.sellerStateOrProvince ?? ""))?.label ?? ""
    },
    buyerInformation: {
      isBuyerTeCertified: jsonData.isBuyerTeCertified || "Yes", // Default value as per the payload
      buyerCbClientNo: jsonData.buyerLicenseNumber || "", // Default value as per the payload
      buyingOnBehalfOfFlag: jsonData.buyingOnBehalfOfFlag || "Yes", // Default value as per the payload
      buyerName: jsonData.buyerName || "",
      buyerTeId: jsonData.buyerTEId || "",
      buyerStreetAddress: jsonData.buyerAddress1 || "",
      buyerAddress2: jsonData.buyerAddress2, // Not available in the source JSON
      buyerAddress3: jsonData.buyerAddress3, // Not available in the source JSON
      buyerPostcode: jsonData.buyerPostcode || "",
      buyerTown: jsonData.buyerTown || "",
      buyerStateOrProvince: jsonData.buyerStateOrProvince || "",
      buyerCountryOrArea: jsonData.buyerCountryOrArea || "",
      buyerCertifiedOrganizationName: jsonData.buyerCertifiedOrganizationName || "",
      buyerScNo: jsonData.buyerSCNumber || "",
      buyerCountryOrAreaDescription: useTransactionCertificateStore.getState().getCountryCodes.find((option: any) => option.value === (jsonData.buyerCountryOrArea ?? ""))?.label ?? "",
      buyerStateOrProvinceDescription: buyerStates.find((option: any) => option.value === (jsonData.buyerStateOrProvince ?? ""))?.label ?? ""
    },
    sellerNonCertifiedTraderInformation: jsonData.nonCertifiedTrader || [],
  };
};